"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * Streams API
 * Manage Tapis Streams API.
 *
 * The version of the OpenAPI document: 1
 * Contact: cicsupport@tacc.utexas.edu
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
var runtime_1 = require("../runtime");
var _1 = require("./");
/**
* @export
* @enum {string}
*/
var RespDeleteOntologyStatusEnum;
(function (RespDeleteOntologyStatusEnum) {
    RespDeleteOntologyStatusEnum["Success"] = "success";
})(RespDeleteOntologyStatusEnum = exports.RespDeleteOntologyStatusEnum || (exports.RespDeleteOntologyStatusEnum = {}));
function RespDeleteOntologyFromJSON(json) {
    return RespDeleteOntologyFromJSONTyped(json, false);
}
exports.RespDeleteOntologyFromJSON = RespDeleteOntologyFromJSON;
function RespDeleteOntologyFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'version': !runtime_1.exists(json, 'version') ? undefined : json['version'],
        'message': !runtime_1.exists(json, 'message') ? undefined : json['message'],
        'status': !runtime_1.exists(json, 'status') ? undefined : json['status'],
        'result': !runtime_1.exists(json, 'result') ? undefined : _1.OntologyFromJSON(json['result']),
    };
}
exports.RespDeleteOntologyFromJSONTyped = RespDeleteOntologyFromJSONTyped;
function RespDeleteOntologyToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'version': value.version,
        'message': value.message,
        'status': value.status,
        'result': _1.OntologyToJSON(value.result),
    };
}
exports.RespDeleteOntologyToJSON = RespDeleteOntologyToJSON;
